module.exports = __webpack_public_path__ + "img/jb_logo_black.9b8b8ccd.png";